// src/App.jsx
import { BrowserRouter, Routes, Route } from "react-router-dom";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import ProtectedRoute from "./helper/ProtectedRoute";
import { ToastHost } from "./components/ui/Toast";
import MasterLayout from "./masterLayout/MasterLayout";

// Pages
import SignInPage from "./pages/Authentication/SignInPage";
import OverviewPage from "./pages/Overview/OverviewPage";
import ThreadsPage from "./pages/Threads/ThreadsPage";
import ThreadDetailPage from "./pages/Threads/ThreadDetailPage";
import GroupsPage from "./pages/Groups/GroupsPage";
import MembersPage from "./pages/Members/MembersPage";
import OriginsPage from "./pages/Origins/OriginsPage";
import ProfilePage from "./pages/Profile/ProfilePage";
import ErrorPage from "./pages/ErrorPage";

/**
 * Routes.
 *
 * The client cabinet: one client system, seen by the people who run it. It is
 * the staff panel's design with the staff register taken out -- there is no
 * list of client systems, identities or panel accounts here, because a
 * customer holds exactly one system and the server scopes every query to it.
 */
function App() {
  return (
    <BrowserRouter>
      <RouteScrollToTop />
      {/* Outside <Routes> so a toast survives the navigation that raised it. */}
      <ToastHost />

      <Routes>
        {/* Public */}
        <Route path="/sign-in" element={<SignInPage />} />

        {/* Everything else sits inside the shell, behind the guard */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <MasterLayout />
            </ProtectedRoute>
          }
        >
          {/* Child pages render inside <Outlet /> */}
          <Route index element={<OverviewPage />} />
          <Route path="muhokamalar" element={<ThreadsPage />} />
          <Route path="muhokamalar/:id" element={<ThreadDetailPage />} />
          <Route path="guruhlar" element={<GroupsPage />} />
          <Route path="ishtirokchilar" element={<MembersPage />} />
          <Route path="domenlar" element={<OriginsPage />} />
          <Route path="profil" element={<ProfilePage />} />

          <Route path="*" element={<ErrorPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
